import React, { createContext, useState } from 'react';

interface ContextType {
  disabled?: boolean;
  setDisabled: (disabled: boolean) => void;
}

export const InquiryContext = createContext<ContextType>({
  setDisabled: () => {}
});

interface Props {
  disabled?: boolean;
  children: JSX.Element | JSX.Element[];
}

export const InquiryProvider: React.FC<Props> = ({ children }) => {
  const [disabled, setDisabled] = useState(false);

  return (
    <InquiryContext.Provider
      value={{
        disabled,
        setDisabled
      }}
    >
      {children}
    </InquiryContext.Provider>
  );
};
